module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon5.3cb3dbab.svg";